import Container from './Container'

export default {
  sashec: new Container()
}
